// One source for the password rule, the line that states it, and the message
// shown when it is not met.
//
// The rule is enforced on the signup form and on the reset-password form, and
// the helper line under the field is the client's approved wording. Keeping the
// three together stops the rule and the sentence describing it from drifting
// apart in one place and not the other.

// 8+ characters, at least one uppercase, one lowercase and one symbol.
export const PASSWORD_REGEX =
  /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*[a-z]).{8,}$/;

export const PASSWORD_HINT = "8+ characters • 1 uppercase letter • 1 symbol";

// Deliberately does not repeat the rule or list the accepted symbols - the
// helper line above is already on screen.
export const PASSWORD_ERROR = "Please meet all password requirements.";

export const isStrongPassword = (value) => PASSWORD_REGEX.test(value || "");
